import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'mj-questions-page',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div fxFlex fxLayout="column">
      <div fxFlex fxLayout="row" class="questions">
        <div fxFlex="100">
          <router-outlet></router-outlet>
        </div>
      </div>
    </div>
  `,
  styles: [
    `
      .questions {
        display: flex;
        padding: 70px;
        background-color: #fafafa;
      }
    `,
  ],
})
export class QuestionsViewComponent {
  constructor() {}
}
